import { NgModule } from "@angular/core";

import { NgxSpineWebglComponent } from "./ngx-spine-webgl.component";

@NgModule({
  declarations: [NgxSpineWebglComponent],
  exports: [NgxSpineWebglComponent]
})
export class NgxSpineModule {}
